import React, { useEffect, useState } from "react";
import Loader from "../form/Loader";
import urls from "../../apiService/urls";
import useSubmit from "../../hooks/http/useSubmit";
import { useHistory } from "react-router-dom";
import useUser from "../../hooks/user/useUser";
import { salesManagerUrls } from "../../apiService/urls";
import { loadLocalState } from "../../utils/localstorage";
import axios from "axios";

const Logout = () => {
    let history = useHistory();
    const [state, { clear }] = useUser();
    const markAttendanceUrl = `${process.env.REACT_APP_BASE_URL}leads/mark_sales_attendance/`;

    const loggedinfo = loadLocalState();

    const [sms, setSms] = useState([
        { id: 26, name: "Sabarinathan" },
        { id: 27, name: "Dhanasekar" },
        { id: 28, name: "Raja" },
        { id: 29, name: "Sivachandraan" },
        { id: 30, name: "Aravindh" },
        { id: 98, name: "Mohan" },
        { id: 32, name: "Arun" },
        { id: 38, name: "Sivakumar" },
        { id: 39, name: "Varun" },
        { id: 40, name: "Venkatesh" },
        { id: 37, name: "Sidharth" },
        { id: 31, name: "Alex pandiyan" },
    ]);

    const handleLogout = async () => {
        const userExists = sms.some((user) => user.id === loggedinfo.id);

        if (userExists) {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}leads/send_off_message/`,
                    { username: loggedinfo.name, id: loggedinfo.id }
                );
                console.log("SMS message triggered for:", loggedinfo.name);
            } catch (error) {
                console.error("Error sending message:", error);
            }
        }

        clear();
        localStorage.clear();
        history.replace("/");
    };

    const initLogout = () => {
        submit({
            url: urls.logout,
            method: "POST",
        });
    };

    const [fetching1, clearAttenance] = useSubmit({
        success: initLogout,
        error: initLogout,
    });

    const [fetching, submit] = useSubmit({
        success: handleLogout,
        error: handleLogout,
        hideToast: true,
    });

    // Called only for sales managers (role 3 or 4) before logout
    const markSalesAttendanceAndLogout = async () => {
        try {
            await axios.post(markAttendanceUrl, {
                sales_id: loggedinfo.emp_id,
                mode: "",
                type:"logout"
            });
            console.log("Sales attendance marked on logout for:", loggedinfo.emp_id);
        } catch (error) {
            console.error("Error marking sales attendance on logout:", error);
        }

        // Always proceed to clear attendance regardless of markAttendanceUrl result
        clearAttenance({
            url: salesManagerUrls.attendance,
            method: "POST",
            data: { project: loggedinfo.current_project, type: 2 },
        });
    };

    useEffect(() => {
        if (state.token) {
            const user_role = parseInt(state.role.id);
            if ((user_role === 3 || user_role === 4) && loggedinfo.current_project != -1) {
                // Sales manager: call markAttendanceUrl first, then clearAttendance, then logout
                markSalesAttendanceAndLogout();
            } else {
                initLogout();
            }
        } else {
            handleLogout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="abs-full d-flex justify-content-center align-items-center">
            {(fetching || fetching1) && <Loader size={30} />}
        </div>
    );
};

export default Logout;